import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { IntroStatusChipComponent } from './intro-status-chip.component';

@NgModule({
  declarations: [IntroStatusChipComponent],
  exports: [IntroStatusChipComponent],
  imports: [CommonModule, FlexLayoutModule, MatIconModule, NzToolTipModule],
})
export class IntroStatusChipModule {}
